import React, { useState, useEffect, useReducer, useRef, useContext } from "react";
import Input from "../UI/Input";
import Button from "../UI/Button";
import AppContext from "../../store/app-context";
import { Plus } from "react-feather";

import styles from "./AddItemForm.module.css";
import { dropRight } from "lodash";

const productReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return {
      value: action.value,
      isValidProduct: action.value.trim().length > 0,
    };
  }
  if (action.type === "INPUT_BLUR") {
    return {
      value: state.value,
      isValidProduct: state.value.trim().length > 0,
    };
  }
  return { value: "", isValidProduct: null };
};

const AddItemForm = (props) => {
  const appCtx = useContext(AppContext);

  let label_enterProduct = 'Enter Catalog#';
  let label_addProduct = 'Add Item';

  if(appCtx && appCtx.bioradResources){
    label_enterProduct = appCtx.bioradResources.Enter_Product_Catalog ? appCtx.bioradResources.Enter_Product_Catalog : 'Enter Catalog#';
    label_addProduct = appCtx.bioradResources.Add_Product ? appCtx.bioradResources.Add_Product : 'Add Item';
  }

  const itemInputRef = useRef();

  const [productInputState, dispatchProduct] = useReducer(productReducer, {
    value: "",
    isValidProduct: null,
  });

  const [isValidForm, setIsValidForm] = useState(false);

  useEffect(() => {
    setIsValidForm(productInputState.isValidProduct);
    return () => {};
  }, [productInputState.isValidProduct]);

  const productChangeHandler = (event) => {
    //setEnteredProduct(event.target.value);
    dispatchProduct({ type: "USER_INPUT", value: event.target.value });
    //setIsValidForm(event.target.value.trim().length > 0);
  };

  const validateProductHandler = () => {
    //setIsValidProduct(enteredProduct.trim().length > 0);
    dispatchProduct({ type: "INPUT_BLUR" });
  };

  const quickAddSubmitHandler = (event) => {
    event.preventDefault();

    if (productInputState.value.trim().length === 0) {
      return;
    }

    //props.onAddItem(productInputState.value, 1);

    props.onAddItem({
      id: Math.random().toString(),
      sku: productInputState.value,
      quantity: 1,
      webRef: props?.quote?.webReference,
    });
    //setEnteredProduct("");
    dispatchProduct({});
  };

  return (
    <form onSubmit={quickAddSubmitHandler}>
      <div
        className={`${styles.control} ${
          productInputState.isValidProduct === false ? styles.invalid : ""
        }`}
      >
        <Input
          ref={itemInputRef}
          label={label_enterProduct}
          input={{
            id: "sku1",
            type: "text",
            class: props?.isNewBrand === true ? styles.newInputType:"inputType",
            value: productInputState.value,
            onChange: productChangeHandler,
            onBlur: validateProductHandler,
          }}
          rebrand={props?.isNewBrand}
        />
        <div className={props?.isNewBrand === true? styles.newbtn : ''}>
          <Button type="submit" className={styles.btn} disabled={!isValidForm}>
            {props?.isNewBrand && (<Plus height={14} width={18} style={{paddingRight:"5px"}}/>)}
            {label_addProduct}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddItemForm;
